<template>
  <div class="slides_popup">
    <div class="d-flex">
      <SelectInput class="col" label="Print" :items="targetOptions" v-model="target" />
      <div class="col">
        <printer-select-with-status
          v-show="target === 1"
          label="Cassette Printer"
          name="cassettePrinter"
          :dataSource="labPrinters"
          v-model="cassettePrinter"
        />
        <printer-select-with-status
          v-show="target === 2"
          label="Paper Slide Printer"
          name="slidePrinter"
          :dataSource="labPrinters"
          v-model="slidePrinter"
        />
        <printer-select-with-status
          v-show="target === 3"
          label="Glass Slide Printer"
          name="glassSlidePrinter"
          :dataSource="labPrinters"
          v-model="glassSlidePrinter"
        />
        <printer-select-with-status
          v-show="target === 4"
          name="worksheetPrinter"
          label="Worksheet Printer"
          :dataSource="labPrinters"
          v-model="worksheetPrinter"
        />
        <div class="row" v-if="target === 5">
          <text-input
            class="col"
            label="File Drop Cassette Printer"
            :value="fileDropCassettePrinterName"
            :disabled="true"
          />
          <select-input
            class="col"
            label="Cassette Tray Name"
            v-model="fileDropCassetteTray"
            :items="fileDropCassetteTrayOptions"
            valueExpr="displayName"
          />
        </div>
        <div class="row" v-if="target === 6">
          <text-input
            class="col"
            label="File Drop Slide Printer"
            :value="fileDropSlidePrinterName"
            :disabled="true"
          />
          <select-input
            class="col"
            label="Slide Tray Name"
            v-model="fileDropSlideTray"
            :items="fileDropSlideTrayOptions"
            valueExpr="displayName"
          />
        </div>
      </div>
    </div>
    <!-- FOR TESTING PURPOSES - REMOVE BEFORE DEPLOYMENT -->
    <!-- <div class="d-flex justify-content-start">
      <TextInput label="Test barcode text" v-model="testBarcode" /><button
        class="btn btn-danger"
        @click="handleScanBarcode(testBarcode)"
      >
        Test
      </button>
    </div> -->
    <div class="d-flex justify-content-between">
      <div class="d-flex text-uppercase flex-column my-2">
        <div v-if="caseQuery" class="d-flex align-items-center justify">
          <h4><span class="text-capitalize">Case Number</span> {{ caseQuery }}</h4>
          <button
            v-if="caseId"
            v-tooltip="'View case orders.'"
            @click="handleProcedureModal"
            class="mx-2 btn btn-outline-primary"
          >
            Orders
          </button>
        </div>
        <div v-if="specimenQuery">
          <span class="text-capitalize">Specimen:</span> {{ specimenQuery }}
        </div>
        <div v-if="blockQuery"><span class="text-capitalize"> Block:</span> {{ blockQuery }}</div>
      </div>
      <div v-if="microtomySlides.length" class="d-flex justify-content-end">
        <button
          :class="'btn btn-' + (microtomyErrorMessage ? 'danger' : 'primary')"
          @click="handleMicrotomyReset"
          :disabled="isResetDisabled"
        >
          {{ microtomyErrorMessage ? "Clear Error" : "Reset Cassette" }}
        </button>
      </div>
      <div v-else></div>
    </div>
    <div v-show="!isCassettes" class="">
      <dx-grid-with-search
        :columnChooser="true"
        v-stream:content-ready="gridReady$"
        v-stream:selection-changed="selection$"
        :columns="slideColumns"
        :dataSource="slideDataStore"
        v-stream:initialized="initialize$"
        :selection="selection"
        title="Cassettes & Slides"
        :focusedRowIndex="1"
        :toolbar="toolbar"
        gridName="slideGrid"
        @initialized="initSlideGrid"
        :searchPanel="searchPanel"
      >
        <template v-slot:extraActions>
          <div class="d-flex">
            <div
              class="d-flex justify-content-end align-items-center"
              v-if="!caseQuery && labSettings.CassetteSlidePrintingShowHoldCodeFilter"
            >
              <tag-input
                class="mr-1"
                :dataSource="holdCodesDataSource"
                placeholder="Search by Hold Codes"
                v-model="holdQuery"
                width="300px"
              />
              <DxSwitch
                class="mr-3"
                v-tooltip="
                  holdSearchType
                    ? 'Searching cases with selected codes'
                    : 'Searching cases without selected holds'
                "
                switched-on-text="Any"
                switched-off-text="None"
                v-model="holdSearchType"
                width="3rem"
              />
            </div>
            <loader size="small" class="align-self-center" v-show="isLoading"></loader>
            <button
              v-if="target === 6"
              @click="printSlidesFileDrop(data)"
              class="btn btn-outline-primary"
            >
              Print
            </button>
            <button
              v-else-if="target !== 5"
              v-stream:click="print$"
              class="btn btn-outline-primary"
            >
              Print
            </button>
          </div>
        </template>
        <template v-slot:microtomyErrorMessage>
          <h4 class="text-danger font-weight-bold">{{ microtomyErrorMessage }}</h4>
        </template>
        <template v-slot:verified-cell="{ data }">
          <Icon
            :class="checkSlideStatus(data.data) ? 'text-success' : 'text-danger'"
            :icon="getStatusIcon(data)"
          />
        </template>
      </dx-grid-with-search>
    </div>
    <div v-show="isCassettes" class="">
      <dx-grid-with-search
        :columnChooser="true"
        v-stream:content-ready="gridReady$"
        v-stream:selection-changed="selection$"
        :columns="cassetteColumns"
        :dataSource="cassetteDataStore"
        v-stream:initialized="initialize$"
        :selection="selection"
        title="Cassettes & Slides"
        :focusedRowIndex="1"
        :toolbar="toolbar"
        gridName="cassetteGrid"
        @initialized="initCassetteGrid"
        :searchPanel="searchPanel"
      >
        <template v-slot:extraActions>
          <div class="d-flex">
            <div
              class="d-flex justify-content-end align-items-center"
              v-if="!caseQuery && labSettings.CassetteSlidePrintingShowHoldCodeFilter"
            >
              <tag-input
                class="mr-1"
                :dataSource="holdCodesDataSource"
                placeholder="Search by Hold Codes"
                v-model="holdQuery"
                width="300px"
              />
              <DxSwitch
                class="mr-3"
                v-tooltip="
                  holdSearchType
                    ? 'Searching cases with selected codes'
                    : 'Searching cases without selected holds'
                "
                switched-on-text="Any"
                switched-off-text="None"
                v-model="holdSearchType"
                width="3rem"
              />
            </div>
            <loader size="small" class="align-self-center" v-show="isLoading"></loader>
            <button
              v-if="target === 5"
              @click="printCassettesFileDrop(data)"
              class="btn btn-outline-primary"
            >
              Print
            </button>
            <button v-else v-stream:click="print$" class="btn btn-outline-primary">Print</button>
          </div>
        </template>
      </dx-grid-with-search>
    </div>
    <modal :status="procedureModal" @close="handleCloseProceduresPopup">
      <procedure-popup :caseId="caseId" />
    </modal>
  </div>
</template>

<script>
import { from, fromEvent, fromEventPattern, throwError, merge } from "rxjs";
import DxGridWithSearch from "./common/DxGridWithSearch.vue";
import { mapState, mapGetters } from "vuex";
import {
  calculateAccessionNumbering,
  filterCellUTC,
  formatDatetimeCell,
  toLetters,
  fromLetters,
  getBinMapFileDrop,
  daysAgo
} from "../modules/helpers";
import {
  catchError,
  concatMap,
  distinctUntilChanged,
  filter,
  last,
  map,
  startWith,
  switchMap,
  take,
  tap,
  throttleTime,
  withLatestFrom
} from "rxjs/operators";
import Modal from "./common/Modal.vue";
import ProcedurePopup from "./ProcedurePopup.vue";
import {
  PrintersApi,
  ReportsApi,
  PrefixApi,
  CasesApi,
  DropdownApi,
  CassettesApi,
  MacrosApi
} from "../services";
import { sortBy } from "lodash";
import Loader from "./common/Loader.vue";
import SelectInput from "@/components/common/SelectInput.vue";
import {
  MacroTypeEnum,
  MicrotomyArtifactTypeEnum,
  MicrotomyScanTypeEnum,
  SpecimenNumbersEnum
} from "@/modules/enums";
import DataSource from "devextreme/data/data_source";
import { handleErrors } from "@/modules/handleErrors";
import PrinterSelectWithStatus from "@/components/PrinterSelectWithStatus.vue";
import { printCassettesFileDrop, printSlidesFileDrop } from "@/modules/printFileDrop";
import TextInput from "./common/TextInput.vue";
import { scanCaseBarcode } from "@/modules/scanCaseBarcode";
import ScannerDetection from "@/modules/scanner";
import moment from "moment";
import TagInput from "./common/TagInput.vue";
import DxSwitch from "devextreme-vue/switch";
import { uniq } from "lodash";
import { AccessionNumberingTypeEnum } from "@/modules/enums";
import Icon from "./common/Icon.vue";
import ArrayStore from "devextreme/data/array_store";

const SLIDE_TABLE_SOURCE = {
  Cassettes: 1,
  Slides: 2,
  GlassSlides: 3,
  Worksheet: 4,
  CassettesFileDrop: 5,
  SlidesFileDrop: 6
};

export default {
  name: "SlidesPopup",
  components: {
    DxGridWithSearch,
    Modal,
    ProcedurePopup,
    Loader,
    SelectInput,
    PrinterSelectWithStatus,
    TextInput,
    TagInput,
    DxSwitch,
    Icon
  },
  props: {
    caseNumberFilter: {
      required: false
    }
  },

  created() {
    PrintersApi.getLabPrinters().then(res => {
      this.labPrinters = new DataSource({
        store: res || [],
        sort: ["displayName"]
      });
    });
    DropdownApi.getPriorities().then(res => {
      this.priorities = res.map(e => e.displayName) || [];
    });
    let targetToSet = this.defaultPrintMode || SLIDE_TABLE_SOURCE.Slides;
    const defaultTarget = this.targetOptions.find(e => e.id === targetToSet);
    if (!defaultTarget) {
      switch (targetToSet) {
        case SLIDE_TABLE_SOURCE.CassettesFileDrop:
          window.notify("Cassette file drop printing is not configured for this lab.", "error");
          targetToSet = SLIDE_TABLE_SOURCE.Cassettes;
          break;
        case SLIDE_TABLE_SOURCE.SlidesFileDrop:
          window.notify("Slide file drop printing is not configured for this lab.", "error");
          targetToSet = SLIDE_TABLE_SOURCE.Slides;
          break;
        default:
          targetToSet = SLIDE_TABLE_SOURCE.Slides;
      }
    }
    this.target = targetToSet;
    this.slidePrinter = this.defaultSlidePrinter;
    this.cassettePrinter = this.defaultCassettePrinter;
    this.worksheetPrinter = this.defaultWorksheetPrinter;
    this.glassSlidePrinter = this.defaultGlassSlidePrinter;
    if (!this.prefixes?.length) {
      this.$store.dispatch("dropdowns/getPrefixes");
    }
  },
  data() {
    return {
      targetTypes: SLIDE_TABLE_SOURCE,
      searchPanel: {
        width: 300,
        visible: !this.caseNumberFilter,
        placeholder: "Search by Case Number"
      },
      target: null,
      labPrinters: [],
      focusedRow: 1,
      grouping: {
        autoExpandAll: false
      },
      slidePrinter: null,
      cassettePrinter: null,
      worksheetPrinter: null,
      glassSlidePrinter: null,
      caseId: "",
      targetSlides: [],
      caseQuery: null,
      specimenQuery: null,
      blockQuery: null,
      procedureModal: false,
      isLoading: false,
      slideGrid: {},
      cassetteGrid: {},
      remoteOperations: {
        filtering: true,
        sorting: true,
        paging: true,
        grouping: true
      },
      selection: {
        allowSelectAll: true,
        mode: "multiple",
        // Having selectAllMode set to allPages was causing an issue where it wasn't possible to unselect all using the checkbox 
        selectAllMode: "page",
        showCheckBoxesMode: "always"
      },
      fileDropCassetteTray: null,
      fileDropSlideTray: null,
      priorities: [],
      lastBarcodeScanTime: 0,
      isAwaitingBarcodeRefresh: false,
      holdQuery: [],
      holdSearchType: true,
      lastBarcodePrint: 0,
      microtomyErrorMessage: "",
      microtomyCassette: null,
      microtomySlides: [],
      isAwaitingMictrotomyCassette: false,
      lastBarcodeScanData: null,
      slideErrorId: null,
      testBarcode: ">A25-77;A;1",
      skipPrintOnNextRefresh: false,
      isResetDisabled: false
    };
  },
  watch: {
    procedureModal(nv) {
      if (!nv && this.targetDataStore.reload) {
        this.targetDataStore.reload();
      }
    },
    microtomySlides(nv, ov) {
      if (nv?.length) {
        this.grid.columnOption("slidePrinted", "filterValue", null);
      } else {
        if (ov?.length) {
          this.skipPrintOnNextRefresh = true;
          this.grid.columnOption("slidePrinted", "filterValue", false);
        }
      }
    }
  },
  domStreams: ["gridReady$", "initialize$", "selection$", "print$", "search$", "printFromEnter$"],
  subscriptions() {
    const keydown$ = fromEvent(document, "keydown");
    const loaded$ = this.$watchAsObservable("targetDataStore", { immediate: true }).pipe(
      switchMap(({ newValue }) => {
        return fromEventPattern(
          handler => newValue.on("loaded", handler),
          handler => newValue.off("loaded", handler)
        );
      })
    );
    const storeData$ = loaded$.pipe(
      map(event => {
        const [data] = event;
        this.targetSlides = data;
        const now = new Date().getTime();
        if (now - this.lastBarcodeScanTime > 3000) {
          const caseQuery = new RegExp(this.caseQuery, "i");
          if (caseQuery) {
            for (const accession of data) {
              if (caseQuery.test(accession.caseNumber)) {
                this.caseId = accession.caseId;
                break;
              }
            }
          }
        }
        return data;
      })
    );

    const printFromBarcode$ = this.$watchAsObservable("isAwaitingBarcodeRefresh").pipe(
      filter(({ newValue }) => newValue),
      distinctUntilChanged(),
      switchMap(() => this.gridReady$),
      filter(() => {
        if (this.microtomySlides?.length) {
          return false;
        }
        const now = new Date().getTime();
        if (now - this.lastBarcodeScanTime > 10000 || now - this.lastBarcodePrint < 3000) {
          return false;
        }
        const rows = this.grid.getVisibleRows();
        this.isAwaitingBarcodeRefresh = false;
        if (rows.length) {
          this.lastBarcodePrint = now;
          return true;
        } else {
          window.notify("No slides pending.", "warning");
          if (this.microtomyCassette) {
            this.microtomyCassette = null;
            const { caseNumber, specimenOrder, blockNum } = this.lastBarcodeScanData;
            this.logMicrotomyScan({
              caseNumber,
              specimenOrder,
              blockNum,
              artifactType: MicrotomyArtifactTypeEnum.Cassette,
              scanResult: MicrotomyScanTypeEnum.Fail,
              errorText: "No pending slides found for cassette."
            });
          }
        }
        return false;
      })
    );

    const grid$ = this.initialize$.pipe(
      filter(data => data?.event?.msg?.component),
      map(data => data.event.msg.component)
    );
    const searchInputFocus$ = this.gridReady$.pipe(
      take(1),
      map(() => {
        const searchPanel = document.querySelector("input[aria-label='Search in the data grid']");
        if (searchPanel) {
          searchPanel.focus();
        }
        return searchPanel;
      })
    );

    const clearSelection$ = this.$watchAsObservable("target", { immediate: true }).pipe(
      withLatestFrom(grid$),
      tap(data => {
        const [{ newValue, oldValue }, grid] = data;
        if (this.hasSelection && grid && (oldValue == 1 || newValue === 1)) {
          grid.clearSelection();
        } else {
          this.$nextTick(() => {
            grid.selectRows(grid.getSelectedRowKeys());
          });
        }
      })
    );

    const printFromEnter$ = keydown$.pipe(
      filter(e => e.keyCode === 13 && document.activeElement === this.$refs.searchPanel)
    );
    const triggerPrint$ = merge(printFromEnter$, this.print$, printFromBarcode$).pipe(
      throttleTime(500),
      filter(() => {
        if (this.skipPrintOnNextRefresh) {
          this.skipPrintOnNextRefresh = false;
          return false;
        }
        let message = "";
        let status = false;
        const { printerName, slidePrinterName } = this.FileDropPrinting;
        switch (this.target) {
          case 1:
            message = "No cassette printer selected.";
            status = Boolean(this.cassettePrinter);
            break;
          case 2:
            message = "No slide printer selected.";
            status = Boolean(this.slidePrinter);
            break;
          case 3:
            message = "No glass slide printer selected.";
            status = Boolean(this.glassSlidePrinter);
            break;
          case 4:
            message = "No worksheet printer selected.";
            status = Boolean(this.worksheetPrinter);
            break;
          case 5:
            message = "This lab is not set up to File Drop print cassettes.";
            status = Boolean(printerName);
            break;
          case 6:
            message = "This lab is not set up to File Drop print slides.";
            status = Boolean(slidePrinterName);
            break;
          default:
            status = false;
            break;
        }
        if (!status) {
          window.notify(message, "warning");
          this.isAwaitingBarcodeRefresh = false;
        }
        return status;
      }),
      map(() => {
        this.isLoading = true;
        let data = [];
        if (this.selectedSlide$.length) {
          data = this.selectedSlide$;
        } else {
          data = this.grid.getVisibleRows().map(e => e.data);
        }
        if (
          this.MicrotomyTracking &&
          this.isAwaitingMictrotomyCassette &&
          [SLIDE_TABLE_SOURCE.Slides, SLIDE_TABLE_SOURCE.GlassSlides].includes(this.target)
        ) {
          if (data?.length) {
            const { cassetteId, specimenId, caseId, blockNum, specimenOrder, caseNumber } = data[0];
            this.microtomyCassette = {
              cassetteId,
              specimenId,
              caseId,
              blockNum,
              specimenOrder,
              caseNumber
            };
            this.logMicrotomyScan({
              artifactType: MicrotomyArtifactTypeEnum.Cassette,
              scanResult: MicrotomyScanTypeEnum.Successful,
              errorText: ""
            });
            this.microtomySlides = data.map(e => {
              return { ...e, hasBeenScanned: false };
            });
          } else {
            const { caseNumber, specimenOrder, blockNum } = this.lastBarcodeScanData;
            this.logMicrotomyScan({
              caseNumber,
              specimenOrder,
              blockNum,
              artifactType: MicrotomyArtifactTypeEnum.Cassette,
              scanResult: MicrotomyScanTypeEnum.Fail,
              errorText: "No pending slides found for cassette."
            });
            this.resetMicrotomyCassette();
          }
        }
        this.isAwaitingMictrotomyCassette = false;
        const { SlidePrintWarning, SlidePrintMax, CassettePrintMax, CassettePrintWarning } =
          this.labSettings;
        if (this.target === SLIDE_TABLE_SOURCE.SlidesFileDrop) {
          return { payload: data };
        }
        let payload;
        let message;
        let targetApi;
        let numberOfItems = 0;
        switch (this.target) {
          case SLIDE_TABLE_SOURCE.Cassettes: //cassetes
            payload = this.labSettings.CassettePrintingUsesBatching
              ? [
                  {
                    labId: this.currentLab,
                    printerId: this.cassettePrinter,
                    cassetteIds: data.map(e => e.cassetteId)
                  }
                ]
              : Object.values(
                  data.reduce((acc, current) => {
                    if (!acc[current.cassetteId]) {
                      acc[current.cassetteId] = {
                        specimenId: current.specimenId,
                        slideId: current.slideId,
                        caseId: current.caseId,
                        numberOfCopies: 1,
                        labId: this.currentLab,
                        printerId: this.cassettePrinter,
                        cassetteId: current.cassetteId
                      };
                    }
                    return acc;
                  }, {})
                );

            numberOfItems = this.labSettings.CassettePrintingUsesBatching
              ? Array.isArray(payload)
                ? payload[0].cassetteIds.length
                : payload.cassetteIds.length
              : payload.length;
            message = `You're about to print ${numberOfItems} cassettes(s). Do you want to continue?`;
            if (numberOfItems > parseInt(CassettePrintMax)) {
              payload = [1];
              targetApi = () => {
                throw new Error(
                  `Your print exceeds the maximum allowed cassettes print (${CassettePrintMax}). <br> Please see contact lab admin to adjust this setting.`
                );
              };
            } else if (numberOfItems >= parseInt(CassettePrintWarning)) {
              if (!this.labSettings.CassettePrintingUsesBatching) {
                payload = [payload];
              }
              targetApi = params =>
                from(window.confirm(message)).pipe(
                  switchMap(res =>
                    res
                      ? this.labSettings.CassettePrintingUsesBatching
                        ? ReportsApi.printBlockLabelsBatch(params)
                        : from(params).pipe(concatMap(data => ReportsApi.printBlockLabels(data)))
                      : throwError("Print Cancelled")
                  )
                );
            } else {
              targetApi = this.labSettings.CassettePrintingUsesBatching
                ? ReportsApi.printBlockLabelsBatch
                : ReportsApi.printBlockLabels;
            }
            break;

          case SLIDE_TABLE_SOURCE.Slides: // Paper Slides
            payload = {
              printerId: this.slidePrinter,
              numberOfCopies: 1,
              slideIds: sortBy(data || [], [
                "caseId",
                "specimenOrder",
                "blockNum",
                "slideLabelNumber"
              ]).map(slide => slide.slideId)
            };

            message = `You're about to print ${payload.slideIds.length} slide(s). Do you want to continue?`;

            if (payload.slideIds.length > parseInt(SlidePrintMax)) {
              payload = [1];
              targetApi = () => {
                throw new Error(
                  `Your print exceeds the maximum allowed slides print (${SlidePrintMax}).`
                );
              };
            } else if (payload.slideIds.length >= parseInt(SlidePrintWarning)) {
              payload = [payload];
              targetApi = params =>
                from(window.confirm(message)).pipe(
                  switchMap(res =>
                    res
                      ? ReportsApi.printSlideLabels(this.currentLab, params)
                      : throwError("Print Cancelled")
                  )
                );
            } else {
              payload = [payload];
              targetApi = params => ReportsApi.printSlideLabels(this.currentLab, params);
            }
            //print slides
            break;

          case SLIDE_TABLE_SOURCE.GlassSlides: // Glass Slides
            payload = this.labSettings.SlidePrintingUsesBatching
              ? [
                  {
                    printerId: this.glassSlidePrinter,
                    labId: this.currentLab,
                    slideIds: sortBy(data || [], [
                      "caseId",
                      "specimenOrder",
                      "blockNum",
                      "slideLabelNumber"
                    ]).map(e => e.slideId)
                  }
                ]
              : sortBy(data || [], ["caseId", "specimenOrder", "blockNum", "slideLabelNumber"]).map(
                  slide => {
                    return {
                      slideId: slide.slideId,
                      caseId: slide.caseId,
                      specimenId: slide.specimenId,
                      printerId: this.glassSlidePrinter,
                      labId: this.currentLab,
                      numberOfCopies: 1,
                      cassetteId: slide.cassetteId
                    };
                  }
                );
            numberOfItems = this.labSettings.SlidePrintingUsesBatching
              ? payload[0].slideIds.length
              : payload.length;
            message = `You're about to print ${numberOfItems} slide(s). Do you want to continue?`;
            if (numberOfItems > parseInt(SlidePrintMax)) {
              payload = [1];
              targetApi = () => {
                throw new Error(
                  `Your print exceeds the maximum allowed slides print (${SlidePrintMax}).`
                );
              };
            } else if (numberOfItems >= parseInt(SlidePrintWarning)) {
              payload = [payload];
              targetApi = params =>
                from(window.confirm(message)).pipe(
                  switchMap(res =>
                    res
                      ? this.labSettings.SlidePrintingUsesBatching
                        ? ReportsApi.printGlassSlidesBatch(data)
                        : from(params).pipe(
                            concatMap(data => ReportsApi.printGlassSlideLabels(data))
                          )
                      : throwError("Print Cancelled")
                  )
                );
            } else {
              targetApi = this.labSettings.SlidePrintingUsesBatching
                ? ReportsApi.printGlassSlidesBatch
                : ReportsApi.printGlassSlideLabels;
            }
            //print Glass slides
            break;

          case SLIDE_TABLE_SOURCE.Worksheet: {
            //Worksheet
            payload = [
              {
                labId: this.currentLab,
                printerId: this.worksheetPrinter,
                slideId: data.map(e => e.slideId),
                numberOfCopies: 1
              }
            ];
            if (payload.slideId > 300) {
              targetApi = () =>
                window.alert(`Your print exceeds the maximum allowed slides print (300).`);
            } else {
              targetApi = ReportsApi.printSlidesWorksheet;
            }
            break;
          }
          default:
            break;
        }
        return { payload, targetApi };
      }),
      switchMap(item => {
        const { payload, targetApi } = item;
        if (this.target === SLIDE_TABLE_SOURCE.SlidesFileDrop) {
          return this.printSlidesFileDrop(payload);
        }
        return from(payload).pipe(
          concatMap(params => targetApi(params)),
          last(),
          tap(() => {
            this.isLoading = false;
          })
        );
      }),
      tap(() => {
        window.notify("Print successful.");
        if (this.isAwaitingBarcodeRefresh) {
          this.isAwaitingBarcodeRefresh = false;
        }
        const { searchPanel } = this.$refs;
        if (searchPanel) {
          this.caseQuery = null;
          this.specimenQuery = null;
          this.blockQuery = null;
          searchPanel.value = "";
          this.grid.clearFilter("search");
        }
        if (this.grid && this.target !== 4) {
          this.grid.clearSelection();
          this.grid.refresh(true);
        }
      }),
      catchError((e, source) => {
        handleErrors(e);
        this.isLoading = false;
        return source;
      })
    );
    const selectedSlide$ = this.selection$.pipe(
      map(({ event }) => {
        const { selectedRowsData } = event.msg;
        return selectedRowsData;
      }),
      startWith([])
    );
    const searchQuery$ = this.gridReady$.pipe(
      map(({ event }) => event.msg),
      take(1),
      switchMap(({ component, element }) => {
        const searchElement = element.querySelector('input[type="text"]');
        return fromEvent(searchElement, "input").pipe(
          distinctUntilChanged(),
          tap(event => {
            const searchQuery = event.target.value;
            const matcher =
              /(?<caseNumber>([a-z]*[0-9]{2}[0-9]+))\|(?<specimenOrder>[\w]+)\|(?<blockNum>[\w]+)/i;

            if (matcher.test(searchQuery)) {
              const match = searchQuery.match(matcher);
              const { caseNumber, specimenOrder, blockNum } = match.groups;
              if (specimenOrder) {
                this.specimenQuery = specimenOrder;
              }
              if (blockNum) {
                this.blockQuery = blockNum;
              }
              return component.searchByText(caseNumber);
            } else {
              this.caseQuery = null;
              this.specimenQuery = null;
              this.blockQuery = null;
            }
            return component.searchByText(searchQuery);
          })
        );
      })
    );
    return {
      searchQuery$,
      selectedSlide$,
      searchInputFocus$,
      panelFocus$: keydown$.pipe(
        filter(e => e.altKey && e.keyCode === 75),
        tap(() => {
          const element = this.$refs.searchPanel;
          if (element) {
            element.focus();
          }
        })
      ),
      storeData$,
      triggerPrint$,

      clearSelection$
    };
  },
  methods: {
    handleProcedureModal() {
      this.$store.dispatch("accessionStore/getCaseDetails", this.caseId);

      this.procedureModal = true;
    },
    handleCloseProceduresPopup() {
      this.procedureModal = false;
      if (this.grid.refresh) {
        this.grid.refresh(true);
      }
    },
    displayBlockNum(slide) {
      let contactSpecimenNumbering = slide.specimenNumbering;
      if (
        contactSpecimenNumbering === SpecimenNumbersEnum.UseLabSettings ||
        !contactSpecimenNumbering
      ) {
        contactSpecimenNumbering = this.labSettings.SpecimenNumberingTypes;
      }
      if (contactSpecimenNumbering === SpecimenNumbersEnum.Numbers) {
        return toLetters(slide.blockNum);
      }
      return slide.blockNum;
    },
    initSlideGrid({ component }) {
      this.slideGrid = component;
    },
    initCassetteGrid({ component }) {
      this.cassetteGrid = component;
    },
    print() {
      this.triggerPrint$.next();
    },
    async printCassettesFileDrop(cassettes) {
      let data = [];
      if (cassettes) {
        data = cassettes;
      } else {
        if (this.selectedSlide$.length) {
          data = this.selectedSlide$;
        } else {
          data = this.storeData$;
        }
      }
      const { CassettePrintMax, CassettePrintWarning } = this.labSettings;
      const selectedTrayName = this.fileDropCassetteTray;
      const defaultFileDropTray = this.FileDropPrinting?.defaultTray;
      this.isLoading = true;
      const labBinMaps = await PrintersApi.getLabBinMaps();
      let payload = [];
      const caseIds = uniq(data.map(e => e.caseId));
      const cases = await CasesApi.getFileDropPrintInfo(caseIds);
      const protocols = await MacrosApi.getMacroListByType(MacroTypeEnum.Protocol);
      for (const cassette of data) {
        let cassetteTrayName = defaultFileDropTray;
        const caseDetails = cases.find(e => e.caseId === cassette.caseId);
        const {
          firstName,
          lastName,
          casePriorityBinMap,
          contactBinMap,
          patientDOB,
          patientMRN,
          collectedOn
        } = caseDetails;
        const { protocolId } = cassette;
        const targetProtocol = protocols.data.find(e => e.macroId === protocolId);
        const prefix = this.prefixes.find(e => e.code === cassette.prefix);
        const binMapTray = getBinMapFileDrop({
          protocol: targetProtocol,
          labBinMaps,
          prefix,
          priorityBinMapId: casePriorityBinMap,
          contactBinMapId: contactBinMap
        });
        if (binMapTray) {
          cassetteTrayName = binMapTray;
        }
        payload.push({
          ...cassette,
          cassetteTrayName,
          patientFirstName: firstName,
          patientLastName: lastName,
          patientDOB,
          patientMRN,
          collectedOn
        });
      }
      const message = `You're about to print ${payload.length} cassettes(s). Do you want to continue?`;
      if (payload.length > parseInt(CassettePrintMax)) {
        window.alert(
          `Your print exceeds the maximum allowed cassettes print (${CassettePrintMax}). <br> Please see contact lab admin to adjust this setting.`
        );
        this.isLoading = false;
        return;
      } else if (payload.length >= parseInt(CassettePrintWarning)) {
        const confirm = await window.confirm(message);
        if (!confirm) {
          window.notify("Print cancelled.", "error");
          this.isLoading = false;
          return;
        }
      }
      try {
        const printed = await printCassettesFileDrop(payload, selectedTrayName);
        if (!printed?.ok) {
          window.alert("An error occurred in printing. Please try again");
          return;
        }
        const cassettesToMark = payload.map(e => e.cassetteId);
        await CassettesApi.markCassettesAsPrinted(cassettesToMark);
        window.notify("Print successful.");
        this.grid.clearSelection();
        this.grid.refresh();
      } catch (error) {
        window.alert("An error occurred in printing. Please try again");
      } finally {
        this.isLoading = false;
      }
    },
    async printSlidesFileDrop(slides) {
      let data = [];
      if (slides) {
        data = slides;
      } else {
        if (this.selectedSlide$.length) {
          data = this.selectedSlide$;
        } else {
          data = this.storeData$;
        }
      }
      const { SlidePrintMax, SlidePrintWarning } = this.labSettings;
      const selectedTrayName = this.fileDropSlideTray;
      const defaultFileDropTray = this.FileDropPrinting?.defaultSlideTray;
      this.isLoading = true;
      const labBinMaps = await PrintersApi.getLabBinMaps();
      let payload = [];
      const caseIds = uniq(data.map(e => e.caseId));
      const cases = await CasesApi.getFileDropPrintInfo(caseIds);
      const protocols = await MacrosApi.getMacroListByType(MacroTypeEnum.Protocol);
      for (const slide of data) {
        let slideTrayName = defaultFileDropTray;
        const caseDetails = cases.find(e => e.caseId === slide.caseId);
        const {
          firstName,
          lastName,
          casePriorityBinMap,
          contactBinMap,
          providerLastName,
          providerFirstName,
          hx,
          patientMRN,
          collectedOn
        } = caseDetails;
        const { protocolId, specimenSite } = slide;
        const targetProtocol = protocols.data.find(e => e.macroId === protocolId);
        const prefix = this.prefixes.find(e => e.code === slide.prefix);
        const binMapTray = getBinMapFileDrop({
          protocol: targetProtocol,
          labBinMaps,
          prefix,
          priorityBinMapId: casePriorityBinMap,
          contactBinMapId: contactBinMap
        });
        if (binMapTray) {
          slideTrayName = binMapTray;
        }
        payload.push({
          ...slide,
          slideTrayName,
          patientFirstName: firstName,
          patientLastName: lastName,
          providerLastName,
          providerFirstName,
          hx,
          patientMRN,
          collectedOn,
          site: specimenSite
        });
      }
      const message = `You're about to print ${payload.length} slides(s). Do you want to continue?`;
      if (payload.length > parseInt(SlidePrintMax)) {
        window.alert(
          `Your print exceeds the maximum allowed slides print (${SlidePrintMax}). <br> Please see contact lab admin to adjust this setting.`
        );
        this.isLoading = false;
        return;
      } else if (payload.length >= parseInt(SlidePrintWarning)) {
        const confirm = await window.confirm(message);
        if (!confirm) {
          window.notify("Print cancelled.", "error");
          this.isLoading = false;
          return;
        }
      }
      try {
        const printed = await printSlidesFileDrop(payload, selectedTrayName);
        if (!printed?.ok) {
          window.alert("An error occurred in printing. Please try again");
          return;
        }
        const slidesToMark = payload.map(e => e.slideId);
        await CassettesApi.markSlidesAsPrinted(slidesToMark);
        window.notify("Print successful.");
        this.grid.clearSelection();
        this.grid.refresh();
      } catch (error) {
        window.alert("An error occurred in printing. Please try again");
      } finally {
        this.isLoading = false;
      }
    },
    async handleScanBarcode(barcode) {
      if (this.slideErrorId) {
        this.updateMicrotomyError("Please reset slide before scanning again.");
        return;
      }
      const now = new Date().getTime();
      if (now - this.lastBarcodeScanTime < 3000) {
        return;
      } else {
        this.lastBarcodeScanTime = now;
      }
      this.devlog("Scanned barcode in Print Slides Popup", barcode);
      this.lastBarcodeScanData = scanCaseBarcode(barcode);
      const { caseNumber, specimenOrder, blockNum, slideId } = this.lastBarcodeScanData;
      const isSlides = [
        SLIDE_TABLE_SOURCE.Slides,
        SLIDE_TABLE_SOURCE.GlassSlides,
        SLIDE_TABLE_SOURCE.SlidesFileDrop
      ].includes(this.target);
      if (this.MicrotomyTracking && isSlides) {
        if (this.microtomyCassette) {
          if (barcode[0] === this.CassetteIdentifier) {
            this.logMicrotomyScan({
              caseNumber,
              specimenOrder,
              blockNum: blockNum
                ? /^\d+$/.test(blockNum)
                  ? parseInt(blockNum)
                  : fromLetters(blockNum)
                : null,
              artifactType: MicrotomyArtifactTypeEnum.Cassette,
              scanResult: MicrotomyScanTypeEnum.Fail,
              errorText: "The anticipated scan is a slide."
            });
            return;
          }
          if (slideId) {
            if (
              calculateAccessionNumbering(caseNumber) !==
              calculateAccessionNumbering(this.microtomyCassette.caseNumber)
            ) {
              this.logMicrotomyScan({
                slideId,
                artifactType: MicrotomyArtifactTypeEnum.Slide,
                scanResult: MicrotomyScanTypeEnum.Fail,
                errorText: "Scanned slide is from a different case than expected."
              });
              return;
            }
            if (specimenOrder !== this.microtomyCassette.specimenOrder) {
              this.logMicrotomyScan({
                slideId,
                artifactType: MicrotomyArtifactTypeEnum.Slide,
                scanResult: MicrotomyScanTypeEnum.Fail,
                errorText: "Scanned slide is from a different specimen than expected."
              });
              return;
            }
            if (
              ![parseInt(blockNum), toLetters(blockNum)].includes(this.microtomyCassette.blockNum)
            ) {
              this.logMicrotomyScan({
                slideId,
                artifactType: MicrotomyArtifactTypeEnum.Slide,
                scanResult: MicrotomyScanTypeEnum.Fail,
                errorText: "Scanned slide is from a different cassette than expected."
              });
              return;
            }
            if (!this.microtomySlides.find(e => e.slideId === parseInt(slideId))) {
              this.logMicrotomyScan({
                slideId,
                artifactType: MicrotomyArtifactTypeEnum.Slide,
                scanResult: MicrotomyScanTypeEnum.Fail,
                errorText: "The slide scan does not match the cassette."
              });
            } else {
              this.handleScanMictrotomySlide(slideId);
            }
          } else {
            this.logMicrotomyScan({
              artifactType: MicrotomyArtifactTypeEnum.Slide,
              scanResult: MicrotomyScanTypeEnum.Fail,
              errorText: "No slide ID found."
            });
          }
          return;
        } else {
          if (barcode[0] === this.CassetteIdentifier) {
            this.isAwaitingMictrotomyCassette = true;
          } else if (barcode[0] === this.SlideIdentifier) {
            this.logMicrotomyScan({
              slideId,
              artifactType: MicrotomyArtifactTypeEnum.Slide,
              scanResult: MicrotomyScanTypeEnum.Fail,
              errorText: "The anticipated scan is a cassette."
            });
            return;
          }
        }
      }
      if (!caseNumber) {
        return;
      }
      const searchPanel = document.querySelector("input[aria-label='Search in the data grid']");
      searchPanel.value = "";
      this.caseQuery = caseNumber;
      const numberSectionsRegex = new RegExp(
        "(?<prefix>[a-z]{1,6})(?<year>[0-9]{4})-(?<number>[0-9]{1,7})",
        "i"
      );
      const {
        groups: { prefix, year, number }
      } = numberSectionsRegex.exec(caseNumber);
      const numberWithoutZeros = number.replace(/^0*/, "");
      this.grid.clearFilter();
      this.grid.clearFilter("search");
      this.grid.clearFilter("dataSource");
      this.grid.columnOption("prefix", "filterValue", prefix);
      this.grid.columnOption("year", "filterValue", year);
      this.grid.columnOption("numberSequence", "filterValue", numberWithoutZeros);
      this.grid.columnOption(isSlides ? "slidePrinted" : "cassettePrinted", "filterValue", false);
      this.grid.columnOption(isSlides ? "cassettePrinted" : "slidePrinted", "filterValue", null);
      if (specimenOrder) {
        this.grid.columnOption("specimenOrder", "filterValue", specimenOrder);
        if (blockNum) {
          this.grid.columnOption(
            "blockNum",
            "filterValue",
            /[a-z]/i.test(blockNum) ? fromLetters(blockNum) : parseInt(blockNum)
          );
          if (isSlides && !this.microtomySlides?.length) {
            this.isAwaitingBarcodeRefresh = true;
          }
        }
      }
    },
    handleClearGridFilters() {
      this.grid.clearFilter("row");
      this.grid.clearFilter("header");
      this.grid.clearFilter("filterValue");
      this.grid.columnOption("caseStatus", "filterValues", this.statusFilter);
      this.grid.clearFilter("search");
      this.grid.clearFilter("dataSource");
    },
    resetMicrotomyCassette(errorText = "") {
      this.logMicrotomyScan({
        ...this.microtomyCassette,
        artifactType: MicrotomyArtifactTypeEnum.Cassette,
        scanResult: MicrotomyScanTypeEnum.Reset,
        errorText
      });
      this.microtomyCassette = null;
      this.microtomySlides = [];
      if (!this.caseNumberFilter) {
        this.caseQuery = null;
      }
      this.clearCaseFilters();
      this.updateMicrotomyError("");
    },
    resetMicrotomySlide() {
      this.logMicrotomyScan({
        ...this.microtomyCassette,
        slideId: this.slideErrorId,
        artifactType: MicrotomyArtifactTypeEnum.Slide,
        scanResult: MicrotomyScanTypeEnum.Reset,
        errorText: ""
      });
      this.slideErrorId = null;
      this.updateMicrotomyError("");
    },
    updateMicrotomyError(text) {
      this.microtomyErrorMessage = text || "";
      if (text && !/closed popup/i.test(text)) {
        let audio = new Audio(require("../../public/assets/sounds/error.mp3"));
        audio.play();
      }
    },
    handleScanMictrotomySlide(slideId) {
      const slideIndex = this.microtomySlides.map(e => e.slideId.toString()).indexOf(slideId);
      if (slideIndex > -1) {
        const slide = this.microtomySlides[slideIndex];
        if (slide.hasBeenScanned) {
          this.logMicrotomyScan({
            slideId,
            artifactType: MicrotomyArtifactTypeEnum.Slide,
            scanResult: MicrotomyScanTypeEnum.Fail,
            errorText: "This slide has already been scanned."
          });
          return;
        }
        this.logMicrotomyScan({
          slideId,
          artifactType: MicrotomyArtifactTypeEnum.Slide,
          scanResult: MicrotomyScanTypeEnum.Successful,
          errorText: ""
        });
        console.log("Insert function here: scanned slide " + slide.slideId);
        this.microtomySlides[slideIndex].hasBeenScanned = true;
        const remainingSlides = this.microtomySlides.filter(e => !e.hasBeenScanned);
        if (remainingSlides.length === 0) {
          window.notify("All slides scanned.");
          this.microtomyCassette = null;
          this.updateMicrotomyError("");
          this.grid.clearFilter();
          this.grid.refresh();
          this.microtomySlides = [];
          const searchPanel = document.querySelector("input[aria-label='Search in the data grid']");
          if (searchPanel) {
            searchPanel.focus();
          }
        }
      } else {
        this.logMicrotomyScan({
          slideId: null,
          artifactType: MicrotomyArtifactTypeEnum.Slide,
          scanResult: MicrotomyScanTypeEnum.Fail,
          errorText: `Slide ${slideId} not found`
        });
      }
    },
    checkSlideStatus(data) {
      const slide = this.microtomySlides.find(e => e.slideId === data.slideId);
      if (slide) {
        return slide.hasBeenScanned;
      }
      return null;
    },
    getStatusIcon({ data }) {
      const status = this.checkSlideStatus(data);
      if (status === null) {
        return null;
      }
      return status ? "check" : "times";
    },
    logMicrotomyScan(payload) {
      payload = { ...this.lastBarcodeScanData, ...payload };
      if (typeof payload?.slideId === "string") {
        payload.slideId = parseInt(payload.slideId);
      }
      this.updateMicrotomyError(payload?.errorText || "");
      CassettesApi.scanMicrotomyBarcode(payload).catch(error => console.log(error));
      if (
        this.microtomyCassette &&
        payload.artifactType === MicrotomyArtifactTypeEnum.Slide &&
        payload.scanResult === MicrotomyScanTypeEnum.Fail
      ) {
        this.slideErrorId = payload.slideId;
      }
    },
    clearCaseFilters() {
      this.grid.columnOption("prefix", "filterValue", null);
      this.grid.columnOption("year", "filterValue", null);
      this.grid.columnOption("numberSequence", "filterValue", null);
      this.grid.columnOption("specimenOrder", "filterValue", null);
      this.grid.columnOption("blockNum", "filterValue", null);
    },
    handleMicrotomyReset() {
      if (this.microtomyErrorMessage) {
        this.microtomyErrorMessage = "";
        this.isResetDisabled = true;
        setTimeout(() => (this.isResetDisabled = false), 1000);
      } else {
        this.resetMicrotomyCassette();
      }
    }
  },
  mounted() {
    this.scanner = new ScannerDetection({
      onComplete: this.handleScanBarcode,
      stopPropogation: true,
      minLength: 4,
      timeBeforeScanTest: 250
    });
  },
  beforeDestroy() {
    if (this.scanner?.stopScanning) {
      this.scanner.stopScanning();
    }
  },
  computed: {
    ...mapState({
      labSettings: state => state.labSettings,
      currentLab: state => state.currentLab,
      applicationSettings: state => state.applicationSettings,
      defaultSlidePrinter: state => state.applicationSettings.defaultSlidePrinter,
      defaultPrintMode: state => state.applicationSettings.defaultPrintMode,
      defaultWorksheetPrinter: state => state.applicationSettings.defaultWorksheetPrinter,
      defaultCassettePrinter: state => state.applicationSettings.defaultCassettePrinter,
      defaultGlassSlidePrinter: state => state.applicationSettings.defaultGlassSlidePrinter,
      FileDropPrinting: state => JSON.parse(state.labSettings.FileDropPrintingConfiguration),
      prefixes: state => state.dropdowns.prefixes,
      MicrotomyTracking: state => state.labSettings.MicrotomyTracking,
      CassetteIdentifier: state => state.labSettings.CassetteIdentifier,
      SlideIdentifier: state => state.labSettings.SlideIdentifier
    }),
    ...mapGetters("accessionStore", ["specimenNumbering"]),
    hasSelection() {
      return this.selectedSlide$.length;
    },
    targetDataStore() {
      if (this.isCassettes) {
        return this.cassetteDataStore;
      }
      return this.slideDataStore;
    },

    numberingType() {
      return this.labSettings?.AccessionNumberingType ?? 0;
    },
    targetBlocks() {
      return [];
    },
    cassetteColumns() {
      return [
        {
          dataField: "slidePrinted",
          allowSearch: false,
          dataType: "boolean",
          lookup: {
            dataSource: [
              { displayName: "Yes", id: true },
              {
                displayName: "No",
                id: false
              }
            ],
            displayExpr: "displayName",
            valueExpr: "id",
            allowSearch: false
          },
          width: "100px"
        },
        {
          width: "100px",
          lookup: {
            dataSource: [
              { displayName: "Yes", id: true },
              {
                displayName: "No",
                id: false
              }
            ],
            displayExpr: "displayName",
            valueExpr: "id"
          },
          filterValue: false,
          dataField: "cassettePrinted",
          dataType: "boolean",
          allowSearch: false
        },
        {
          dataField: "priority",
          dataType: "string",
          allowSearch: false,
          lookup: {
            dataSource: this.priorities
          }
        },
        {
          dataField: "protocol",
          dataType: "string",
          allowFiltering: true,
          allowSearch: false
        },
        {
          dataField: "caseNumber",
          calculateFilterExpression: value => {
            const getCaseNumberRegex = caseNumber => {
              const regex = /(?<prefix>[a-z]{1,6})?(?<year>\d{4})-(?<number>\d{7})/i.exec(
                caseNumber
              );
              if (regex?.groups) {
                return regex.groups;
              }
              return {};
            };
            function createFilter(caseNumber, specimenOrder, blockNum) {
              const { prefix, year, number } = getCaseNumberRegex(caseNumber);
              let filter = [];
              if (prefix) {
                filter.push(["prefix", "=", prefix]);
              }
              if (year) {
                filter.push(["year", "=", year]);
              }
              if (number) {
                filter.push(["numberSequence", "=", number.replace(/^0*/, "")]);
              }
              if (specimenOrder) {
                filter.push(["specimenOrder", "=", specimenOrder]);
              }
              if (blockNum) {
                filter.push([
                  "blockNum",
                  "=",
                  /\d/.test(blockNum) ? blockNum : fromLetters(blockNum + "")
                ]);
              }
              if (filter?.length) {
                return filter;
              }
              return ["caseNumber", "contains", caseNumber];
            }

            if (this.numberingType === AccessionNumberingTypeEnum.Pathology) {
              const fullCaseNumber = calculateAccessionNumbering(value, this.numberingType);
              if (!/[a-z]/i.test(fullCaseNumber)) {
                return createFilter(fullCaseNumber);
              }
            }
            const parsed = scanCaseBarcode(value);
            if (parsed) {
              const { caseNumber, specimenOrder, blockNum } = parsed;
              return createFilter(caseNumber, specimenOrder, blockNum);
            }
            return ["caseNumber", "contains", value];
          },
          dataType: "string",
          visible: false
        },
        {
          dataField: "prefix",
          dataType: "string",
          lookup: {
            displayExpr: "code",
            valueExpr: "code",
            dataSource: PrefixApi.searchStore
          },
          sortIndex: this.isPrefixNumbering ? 0 : null,
          sortOrder: this.isPrefixNumbering ? "asc" : null,
          allowSearch: false
        },
        {
          dataField: "year",
          dataType: "number",
          sortIndex: 1,
          sortOrder: "desc",
          allowSearch: false
        },
        {
          dataField: "numberSequence",
          caption: "Case Number",
          dataType: "number",
          sortIndex: 2,
          sortOrder: "asc",
          allowSearch: false
        },
        {
          dataField: "specimenOrder",
          caption: "Specimen",
          width: "70px",
          dataType: "string",
          sortIndex: 3,
          sortOrder: "asc",
          filterValue: this.specimenQuery,
          allowSearch: false
        },
        {
          dataField: "blockNum",
          width: "70px",
          dataType: "string",
          caption: "Block",
          sortIndex: 4,
          sortOrder: "asc",
          filterValue: this.blockQuery,
          allowFiltering: true,
          allowSorting: true,
          allowSearching: true,
          calculateCellValue: slide => this.displayBlockNum(slide),
          allowSearch: false
        },
        {
          dataField: "orderDescription",
          dataType: "string",
          allowFiltering: true,
          allowSearch: false
        },
        {
          dataField: "userAdded",
          dataType: "string",
          caption: "Added By",
          allowSearch: false
        },
        {
          dataField: "userAddedDateTime",
          caption: "Added Time",
          dataType: "datetime",
          calculateFilterExpression: filterCellUTC("userAddedDateTime"),
          calculateCellValue(data) {
            return formatDatetimeCell(data.userAddedDateTime);
          },
          allowSearch: false
        },
        {
          dataField: "isHistologyAutoComplete",
          caption: "Auto Histo",
          dataType: "boolean",
          lookup: {
            dataSource: [
              { displayName: "Yes", id: true },
              {
                displayName: "No",
                id: false
              }
            ],
            displayExpr: "displayName",
            valueExpr: "id"
          },
          allowSearch: false
        },
        {
          dataField: "isPathologistAutoComplete",
          caption: "Auto Path",
          dataType: "boolean",
          lookup: {
            dataSource: [
              { displayName: "Yes", id: true },
              {
                displayName: "No",
                id: false
              }
            ],
            displayExpr: "displayName",
            valueExpr: "id"
          },
          allowSearch: false
        },
        { dataField: "printedBy", dataType: "string" },
        {
          dataField: "printedOn",
          dataType: "date",
          calculateFilterExpression: filterCellUTC("printedOn"),
          calculateCellValue(data) {
            if (!data?.printedOn) {
              return "";
            }
            return formatDatetimeCell(data.printedOn);
          }
        }
      ];
    },
    slideColumns() {
      return [
        {
          dataField: "slidePrinted",
          allowSearch: false,
          dataType: "boolean",
          lookup: {
            dataSource: [
              { displayName: "Yes", id: true },
              {
                displayName: "No",
                id: false
              }
            ],
            displayExpr: "displayName",
            valueExpr: "id"
          },
          width: "100px",
          filterValue: false
        },
        {
          width: "100px",
          lookup: {
            dataSource: [
              { displayName: "Yes", id: true },
              {
                displayName: "No",
                id: false
              }
            ],
            displayExpr: "displayName",
            valueExpr: "id"
          },
          dataField: "cassettePrinted",
          dataType: "boolean",
          allowSearch: false
        },
        {
          dataField: "verified",
          visible: Boolean(this.MicrotomyTracking && this.microtomySlides.length),
          calculateCellValue: data => this.checkSlideStatus(data),
          cellTemplate: "verified-cell",
          allowSearch: false,
          allowSorting: false
        },
        {
          dataField: "priority",
          dataType: "string",
          allowSearch: false,
          lookup: {
            dataSource: this.priorities
          }
        },
        {
          dataField: "protocol",
          dataType: "string",
          allowFiltering: true,
          allowSearch: false
        },
        {
          dataField: "caseNumber",
          calculateFilterExpression: value => {
            const getCaseNumberRegex = caseNumber => {
              const regex = /(?<prefix>[a-z]{1,6})?(?<year>\d{4})-(?<number>\d{7})/i.exec(
                caseNumber
              );
              if (regex?.groups) {
                return regex.groups;
              }
              return {};
            };
            function createFilter(caseNumber, specimenOrder, blockNum) {
              const { prefix, year, number } = getCaseNumberRegex(caseNumber);
              let filter = [];
              if (prefix) {
                filter.push(["prefix", "=", prefix]);
              }
              if (year) {
                filter.push(["year", "=", year]);
              }
              if (number) {
                filter.push(["numberSequence", "=", number.replace(/^0*/, "")]);
              }
              if (specimenOrder) {
                filter.push(["specimenOrder", "=", specimenOrder]);
              }
              if (blockNum) {
                filter.push([
                  "blockNum",
                  "=",
                  /\d/.test(blockNum) ? blockNum : fromLetters(blockNum + "")
                ]);
              }
              if (filter?.length) {
                return filter;
              }
              return ["caseNumber", "contains", caseNumber];
            }

            if (this.numberingType === AccessionNumberingTypeEnum.Pathology) {
              const fullCaseNumber = calculateAccessionNumbering(value, this.numberingType);
              if (!/[a-z]/i.test(fullCaseNumber)) {
                return createFilter(fullCaseNumber);
              }
            }
            const parsed = scanCaseBarcode(value);
            if (parsed) {
              const { caseNumber, specimenOrder, blockNum } = parsed;
              return createFilter(caseNumber, specimenOrder, blockNum);
            }
            return ["caseNumber", "contains", value];
          },
          dataType: "string",
          visible: false
        },
        {
          dataField: "prefix",
          dataType: "string",
          lookup: {
            displayExpr: "code",
            valueExpr: "code",
            dataSource: PrefixApi.searchStore
          },
          sortIndex: this.isPrefixNumbering ? 0 : null,
          sortOrder: this.isPrefixNumbering ? "asc" : null,
          allowSearch: false
        },
        {
          dataField: "year",
          dataType: "number",
          sortIndex: 1,
          sortOrder: "desc",
          allowSearch: false
        },
        {
          dataField: "numberSequence",
          caption: "Number",
          sortIndex: 2,
          sortOrder: "asc",
          dataType: "number",
          calculateCellValue(data) {
            return data.numberSequence.toString().padStart(7, "0");
          },
          allowSearch: false
        },
        {
          dataField: "specimenOrder",
          width: "70px",
          caption: "Specimen",
          dataType: "string",
          sortIndex: 3,
          sortOrder: "asc",
          filterValue: this.specimenQuery,
          allowSearch: false
        },
        {
          dataField: "blockNum",
          dataType: "number",
          width: "70px",
          caption: "Block",
          sortIndex: 4,
          sortOrder: "asc",
          calculateCellValue: slide => this.displayBlockNum(slide),
          filterValue: this.blockQuery,
          allowSearch: false
        },
        {
          dataField: "slideLabelNumber",
          dataType: "number",
          caption: "Slide Number",
          sortIndex: 5,
          sortOrder: "asc",
          allowSearch: false
        },
        {
          dataField: "slideLabelDescription",
          dataType: "string",
          caption: "Slide Label",
          allowSearch: false
        },
        {
          dataField: "orderDescription",
          dataType: "string",
          allowFiltering: true,
          allowSearch: false
        },
        {
          dataField: "userAdded",
          dataType: "string",
          caption: "Added By",
          allowSearch: false
        },
        {
          dataField: "userAddedDateTime",
          caption: "Added Time",
          dataType: "datetime",
          calculateFilterExpression: filterCellUTC("userAddedDateTime"),
          calculateCellValue(data) {
            return formatDatetimeCell(data.userAddedDateTime);
          },
          allowSearch: false
        },
        {
          dataField: "printedOn",
          dataType: "datetime",
          calculateFilterExpression: filterCellUTC("printedOn"),
          calculateCellValue(data) {
            if (data?.printedOn) {
              return formatDatetimeCell(data.printedOn);
            }
            return "";
          },
          allowSearch: false
        },
        {
          dataField: "printedBy",
          dataType: "string",
          allowSearch: false
        },
        {
          dataField: "isHistologyAutoComplete",
          caption: "Auto Histo",
          dataType: "boolean",
          lookup: {
            dataSource: [
              { displayName: "Yes", id: true },
              {
                displayName: "No",
                id: false
              }
            ],
            displayExpr: "displayName",
            valueExpr: "id"
          },
          allowSearch: false
        },
        {
          dataField: "isPathologistAutoComplete",
          caption: "Auto Path",
          dataType: "boolean",
          lookup: {
            dataSource: [
              { displayName: "Yes", id: true },
              {
                displayName: "No",
                id: false
              }
            ],
            displayExpr: "displayName",
            valueExpr: "id"
          },
          allowSearch: false
        }
      ];
    },
    targetOptions() {
      let options = [
        {
          displayName: "Cassettes",
          id: 1
        },
        {
          displayName: "Slides",
          id: 2
        },
        {
          displayName: "Slides (Glass)",
          id: 3
        },
        {
          displayName: "Worksheet",
          id: 4
        }
      ];
      if (this.FileDropPrinting?.printerName) {
        options.push({
          displayName: "Cassettes (File Drop)",
          id: 5
        });
      }
      if (this.FileDropPrinting?.slidePrinterName) {
        options.push({
          displayName: "Slides (File Drop)",
          id: 6
        });
      }
      return options;
    },
    fileDropCassettePrinterName() {
      return this.FileDropPrinting?.printerName;
    },
    fileDropSlidePrinterName() {
      return this.FileDropPrinting?.slidePrinterName;
    },
    fileDropCassetteTrayOptions() {
      return this.FileDropPrinting?.trayOptions || [];
    },
    fileDropSlideTrayOptions() {
      return this.FileDropPrinting?.slideTrayOptions || [];
    },
    holdCodesDataSource() {
      const now = moment().format("yyyy-MM-DDTHH:mm:ss");
      const effectiveFilter = [
        [["effectiveOn", "<", now], "or", ["effectiveOn", "=", null]],
        "and",
        [["expiryOn", ">", now], "or", ["expiryOn", "=", null]]
      ];
      return new DataSource({
        store: DropdownApi.searchHoldCodes,
        filter: effectiveFilter,
        sort: ["displayName"]
      });
    },
    cassetteDataStore() {
      if (!this.isCassettes) {
        return [];
      }
      let query = "";
      if (this.holdQuery.length) {
        query = { hcids: this.holdQuery, any: this.holdSearchType };
      }
      return new DataSource({
        store: ReportsApi.cassetteListWithHolds(query),
        filter: this.caseNumberFilter
          ? ["caseNumber", "=", this.caseNumberFilter]
          : this.dateRangeFilter
      });
    },
    slideDataStore() {
      if (this.isCassettes) {
        return [];
      }
      if (this.microtomySlides.length) {
        return new ArrayStore({ data: this.microtomySlides });
      }
      let query = "";
      if (this.holdQuery.length) {
        query = { hcids: this.holdQuery, any: this.holdSearchType };
      }
      return new DataSource({
        store: ReportsApi.slideListWithHolds(query),
        filter: this.caseNumberFilter
          ? ["caseNumber", "=", this.caseNumberFilter]
          : this.dateRangeFilter
      });
    },
    isPrefixNumbering() {
      return this.labSettings.AccessionNumberingType === AccessionNumberingTypeEnum.Prefix;
    },
    isCassettes() {
      return [this.targetTypes.Cassettes, this.targetTypes.CassettesFileDrop].includes(this.target);
    },
    grid() {
      return this.isCassettes ? this.cassetteGrid : this.slideGrid;
    },
    dateRangeFilter() {
      const numberOfDays = this.labSettings.CassetteSlidePrintDateLimit || 14;
      return ["userAddedDateTime", ">", daysAgo(numberOfDays)];
    },
    toolbar() {
      return {
        items: [
          !this.isCassettes && { location: "center", template: "microtomyErrorMessage" },
          { location: "after", template: "extraActions" }
        ]
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.searchInput {
  width: 300px;
  &::after {
    top: 12%;
    right: 10%;
    position: absolute;
    content: "ALT+K";
    font-weight: 500;
    border: 0.5px solid gray;
    padding: 0.25rem 0.5rem;
    border-radius: 5px;
    color: gray;
  }
  &:focus-within {
    &::after {
      display: none;
    }
  }
}
.slides_popup {
  width: 90vw;
}
</style>
